import useSWR, { SWRConfiguration } from 'swr';
import useSWRMutation from 'swr/mutation';
import { DjangoParams, PaginatedRequest } from 'APIs/types';
import letrusAPI from '../axiosInstance';
import { Notification, SidebarNotification } from './types';

export function useFetchNotifications(params?: DjangoParams) {
  const queryParams = {
    ...params,
    created__year: new Date().getFullYear(),
  };

  return useSWR<PaginatedRequest<Notification[]>, unknown>(
    ['/api/v1/notification_logs/', queryParams],
    ([url]) => letrusAPI(url, { params: queryParams }).then((res) => res.data),
    { revalidateOnFocus: false, shouldRetryOnError: false }
  );
}

export function useUpdateNotification() {
  return useSWRMutation<
    Notification,
    Error,
    string,
    { notificationId: number; notificationData: Partial<Notification> }
  >('/api/v1/notification_logs/', async (url, { arg }) => {
    const { notificationId, notificationData } = arg;
    const response = await letrusAPI(`${url}${notificationId}/`, {
      method: 'PATCH',
      data: notificationData,
    });

    return response.data;
  });
}

export function useFetchSidebarNotification(swrConfig?: SWRConfiguration) {
  return useSWR<SidebarNotification, unknown>(
    '/api/v1/teacher_notifications/',
    (url) => letrusAPI(url).then((res) => res.data),
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
      ...swrConfig,
    }
  );
}
